import React from 'react';
import PropTypes from 'prop-types';
import { css } from 'styled-components';
import { Grid, Col } from '../../interfaces';
import { Container, Margin } from '../../base';

import { withTranslation, Router } from '../../libs/i18n';
import {
  FooterWrapper,
  FooterBottom,
  FooterBottomFlex,
  FooterSocial,
  FooterResourceList,
  FooterAddressList,
  FooterAddressListIcon,
  FooterAddressListDesc
} from './Styled';
import Link from '../../components/basic/Link';
import TouchableItem from '../../components/basic/TouchableItem';

const year = new Date().getFullYear();

const Footer = ({ t }) => (
  <React.Fragment>
    <FooterWrapper>
      <Container>
        <Grid>
          <Col lg={3} md={6} sm={12}>
            <img src="/static/images/logo/logo-rpt-white.svg" alt="Rupiah Token Logo" />
            <Margin vertical={32}>
              <div>
                <h5 style={{ fontWeight: 'normal' }}>
                  {t('footer.media_partner.title', 'Media Partner')}
                </h5>
              </div>
              <div
                css={css`
                  width: 150px;
                  filter: grayscale(100%);
                `}
              >
                <a
                  href="https://coinvestasi.com/press-releases/rupiah-token-hadir-di-binance-chain/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-coinvestasi.png"
                    alt="logo-coinvestasi"
                  />
                </a>
              </div>
              <FooterSocial>
                {/* ### Anthony: Hiding these because we don't have community manager to manage FB/Insta, and looks weird if there's only Telegram icon
                <li>
                  <a href="/" target="+_blank">
                    <img
                      src="../../../../static/images/social/ic-facebook.svg"
                      alt="Icon - Facebook"
                    />
                  </a>
                </li>
                <li>
                  <a href="/" target="+_blank">
                    <img
                      src="../../../../static/images/social/ic-instagram.svg"
                      alt="Icon - Instagram"
                    />
                  </a>
                </li>
                <li>
                  <a href="/" target="+_blank">
                    <img
                      src="../../../../static/images/social/ic-telegram.svg"
                      alt="Icon - Telegram"
                    />
                  </a>
                </li>
                */}
              </FooterSocial>
            </Margin>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <h5>{t('footer.resources.title', 'Resources')}</h5>
            <Margin bottom={40}>
              <FooterResourceList>
                <li>
                  <Link href="/">{t('menu.home', 'Home')}</Link>
                </li>
                <li>
                  <Link href="/about">{t('menu.about', 'Our Team')}</Link>
                </li>
                {/* <li>
                  <Link href="/career">
                    <a href="/career">Career</a>
                  </Link>
                </li> */}
                <li>
                  <TouchableItem
                    onClick={() =>
                      Router.push({
                        pathname: '/',
                        hash: 'reports'
                      })
                    }
                  >
                    {t('landing.reports.title', 'Whitepaper')}
                  </TouchableItem>
                </li>
                {/* <li>
                  <Link href="/monthly-attestation-reports">
                    <a href="/monthly-attestation-reports">Monthly Bank Reports</a>
                  </Link>
                </li> */}
                <li>
                  <Link href={t('menu.faq.link', 'https://rupiahtoken.zendesk.com/hc/en-us')}>
                    {t('menu.faq', 'FAQ')}
                  </Link>
                </li>
                <li>
                  <Link
                    href={t('menu.blog.link', 'https://rupiahtoken.com/blog')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('menu.blog', 'Blog')}
                  </Link>
                </li>
                <li>
                  <Link
                    href={t('menu.career.link', '/career')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('menu.career', 'Career')}
                  </Link>
                </li>
                <li>
                  <Link
                    href={t(
                      'landing.examine.idrt.url',
                      'https://etherscan.io/token/0x998FFE1E43fAcffb941dc337dD0468d52bA5b48A'
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('menu.idrt', 'IDRT')}
                  </Link>
                </li>
                <li>
                  <Link
                    href={t(
                      'landing.examine.idrtb.url',
                      'https://explorer.binance.org/asset/IDRTB-178'
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('menu.idrtb', 'IDRTB')}
                  </Link>
                </li>
                <li>
                  <Link
                    href={t(
                      'menu.bug_bounty.url',
                      'https://rupiahtoken.com/blog/bug-bounty-program'
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('menu.bug_bounty', 'Bug Bounty')}
                  </Link>
                </li>
              </FooterResourceList>
            </Margin>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <h5>{t('footer.contact_us.title', 'Contact Us')}</h5>
            <Margin bottom={40}>
              <FooterAddressList>
                <FooterAddressListIcon>
                  <img src="/static/images/social/ic-location.svg" alt="Icon - Location" />
                </FooterAddressListIcon>
                <FooterAddressListDesc>
                  <p>
                    {t(
                      'rupiahtoken.address',
                      'The City Tower Lantai 27, Jalan M.H Thamrin No.81, Menteng, Jakarta Pusat - DKI Jakarta 10310'
                    )}
                  </p>
                </FooterAddressListDesc>
              </FooterAddressList>
              <FooterAddressList>
                <FooterAddressListIcon>
                  <img src="/static/images/social/ic-email.svg" alt="Icon - Email" />
                </FooterAddressListIcon>
                <FooterAddressListDesc>
                  <a
                    href={`mailto:${t('rupiahtoken.support_email', 'support@rupiahtoken.com')}`}
                    target="_blank"
                    rel="noreferrer noopener"
                    style={{ color: '#FFF', lineHeight: '22.4px' }}
                  >
                    {t('rupiahtoken.support_email', 'support@rupiahtoken.com')}
                  </a>
                </FooterAddressListDesc>
              </FooterAddressList>
              <FooterAddressList>
                <FooterAddressListIcon>
                  <img
                    src="/static/images/social/ic-telegram.svg"
                    style={{ height: '22px' }}
                    alt="Icon - Telegram"
                  />
                </FooterAddressListIcon>
                <FooterAddressListDesc>
                  <a
                    href={t(
                      'rupiahtoken.join_telegram_url',
                      'https://t.me/joinchat/IecbjxEy6xVf1dyZhGZxpw'
                    )}
                    target="_blank"
                    rel="noreferrer noopener"
                    style={{ color: '#FFF', lineHeight: '22.4px' }}
                  >
                    {t('footer.join_our_telegram', 'Join our Telegram')}
                  </a>
                </FooterAddressListDesc>
              </FooterAddressList>
              {/* ### Anthony: Commenting this out until we have proper phone number ###
              <FooterAddressList>
                <FooterAddressListIcon>
                  <img
                    src="../../../../static/images/social/ic-phone.svg"
                    alt="Icon - Phone"
                  />
                </FooterAddressListIcon>
                <FooterAddressListDesc>
                  <p>
                    +6285128649456
                    <br />
                    (mon-Fri 9AM - 9PM GMT +7)
                  </p>
                </FooterAddressListDesc>
              </FooterAddressList>
              */}
            </Margin>
          </Col>
          <Col lg={3} md={6} sm={12}>
            <h5>{t('footer.audit_certificate.title', 'Audit Certificate')}</h5>
            <div
              css={css`
                a {
                  color: ${({ theme: { colors } }) => colors.light.primary};
                  font-weight: 600;
                }
              `}
            >
              <Margin top={32} bottom={16}>
                <a
                  href="https://certik.org/redirect.html?type=certificate&key=f03cd47f34550c8c92e34b49b2c31b52acd29c48633b1fe23948c0ed670b2b02"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <img
                    style={{
                      background: '#fff',
                      padding: '15px',
                      borderRadius: '5px'
                    }}
                    src="/static/images/badge/certik.png"
                    alt="Badge - Certik"
                  />
                </a>
              </Margin>
              <p>
                {t('footer.audit_certificate.subtitle_1', 'Rupiah Token is audited and')}
                <br />
                {t('footer.audit_certificate.subtitle_2', 'certified by')}
                &nbsp;
                <a
                  href="https://certik.org/redirect.html?type=certificate&key=f03cd47f34550c8c92e34b49b2c31b52acd29c48633b1fe23948c0ed670b2b02"
                  target="_blank"
                  rel="noreferrer noopener"
                  style={{ color: '#fff' }}
                >
                  {t('footer.audit_certificate.subtitle_link', 'CertiK')}
                </a>
                .
              </p>
            </div>
          </Col>
        </Grid>
      </Container>
    </FooterWrapper>
    <FooterBottom>
      <Container>
        <FooterBottomFlex>
          <p>
            &copy;
            {year}
            &nbsp;
            {t('rupiahtoken.company_name', 'PT Rupiah Token Indonesia')}
          </p>
          <div>
            <Link href="/legal/terms">
              <a href="/legal/terms">{t('footer.terms_and_conditions', 'Terms and Conditions')}</a>
            </Link>
            |
            <Link href="/legal/privacy">
              <a href="/legal/privacy">{t('footer.privacy_policy', 'Privacy Policy')}</a>
            </Link>
          </div>
        </FooterBottomFlex>
      </Container>
    </FooterBottom>
  </React.Fragment>
);

Footer.propTypes = {
  t: PropTypes.func
};

export default withTranslation('common')(Footer);
